import { z } from 'zod';
import { MoneySchema } from './common.js';
export const BankAccountTypeSchema = z.enum(['CURRENT', 'SAVINGS', 'FIXED', 'FOREIGN']);
export const BankAccountSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    code: z.string().min(1).max(32),
    bank: z.string().min(1),
    accNo: z.string().min(1),
    nameTh: z.string().min(1),
    type: BankAccountTypeSchema,
    branch: z.string().nullable().optional(),
    // FK-by-value -> ChartOfAccount.code (cash/bank GL, same company). null => the
    // money-path posters fall back to the company-level BANK_PRIMARY key.
    glAccountCode: z.string().nullable().optional(),
    balance: z.union([MoneySchema, z.coerce.number().nonnegative()]),
    isActive: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateBankAccountSchema = BankAccountSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateBankAccountSchema = CreateBankAccountSchema.partial().omit({
    companyId: true,
});
//# sourceMappingURL=bank-account.js.map